(function() {
    var urlParams = new URLSearchParams(window.location.search);
    var quantity = urlParams.get('quantity');

    if (!quantity) {
        return;
    }

    function yieldDocumentReady() {
        return new Promise(function(resolve) {
            if (document.readyState !== "loading") {
                resolve();
            } else {
                document.addEventListener("DOMContentLoaded", function () {
                    resolve();
                });
            }
        });
    }

    function yieldForExpivi() {
        return new Promise(function(resolve, reject) {
            if (!window.expivi) {
                return reject('Expivi not initialized');
            }

            var timeoutHandle;
            timeoutHandle = setTimeout(function() {
                delete timeoutHandle;
                reject('Expivi ready timeout');
            }, 60000);

            window.expivi._events.onChange.subscribe((e) => {
                if (!timeoutHandle || e.name !== 'product_finished_loading') {
                    return;
                }

                clearTimeout(timeoutHandle);
                resolve();
            });
        });
    }

    Promise.resolve()
        .then(function() {
            return yieldDocumentReady();
        })
        .then(function () {
            return yieldForExpivi();
        })
        .then(function () {
            window.expivi.setProductAttributeByKey('amount', quantity);
        })
        .catch(function(e) {
            console.log(e);
        });
})();